@let fieldSettings = fieldsSettings$ | async;

@if (fieldSettings) {
  <form [formGroup]="form">
    <ion-list lines="full" [inset]="true" class="no-last-line">
      <ion-list-header> Estimated Net Sheet for:</ion-list-header>
      @let customerInformationPartyTypes = customerInformationPartyTypes$ | async;

      @if (customerInformationPartyTypes && customerInformationPartyTypes.length > 1) {
        <ion-radio-group formControlName="customerInformationPartyType">
          @for (partyType of customerInformationPartyTypes; track partyType) {
            <ion-select-option [value]="partyType">{{ partyType }}</ion-select-option>
            <ion-item>
              <ion-radio class="tw:text-xs" [value]="partyType">{{
                netSheetCustomerTypeLabelEnum[partyType]
              }}</ion-radio>
            </ion-item>
          }
        </ion-radio-group>
      }

      <ion-item-divider>
        {{
          form.controls.customerInformationPartyType.value
            ? netSheetCustomerTypeLabelEnum[form.controls.customerInformationPartyType.value]
            : 'Party'
        }}
      </ion-item-divider>

      @if (fieldSettings['customerInformationPartyFullName'].visible) {
        <ion-item>
          <ion-input
            formControlName="customerInformationPartyFullName"
            labelPlacement="stacked"
            placeholder="John Doe"
            redErrorMessage
            [redRequired]="fieldSettings['customerInformationPartyFullName'].required === true"
            inputmode="text"
            type="text"
          >
            <div slot="label" class="tw:whitespace-normal">
              Full Name
              @if (fieldSettings['customerInformationPartyFullName'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['customerInformationPartyFirstName'].visible) {
        <ion-item>
          <ion-input
            formControlName="customerInformationPartyFirstName"
            labelPlacement="stacked"
            placeholder="John"
            inputmode="text"
            redErrorMessage
            [redRequired]="fieldSettings['customerInformationPartyFirstName'].required === true"
            type="text"
          >
            <div slot="label" class="tw:whitespace-normal">
              First Name
              @if (fieldSettings['customerInformationPartyFirstName'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['customerInformationPartyLastName'].visible) {
        <ion-item>
          <ion-input
            formControlName="customerInformationPartyLastName"
            labelPlacement="stacked"
            placeholder="Doe"
            inputmode="text"
            redErrorMessage
            [redRequired]="fieldSettings['customerInformationPartyLastName'].required === true"
            type="text"
          >
            <div slot="label" class="tw:whitespace-normal">
              Last Name
              @if (fieldSettings['customerInformationPartyLastName'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }
    </ion-list>
  </form>
}
